export default __webpack_public_path__ + "static/media/net-icon.864d9c65.webp";